import initBondCards from '../../scripts/initBondCards'

export default {
	data() {
		return {
			partnersCreditingAndRefinancingConditions: 10,
			partnersAppraisalAndObjects: 10,
			partnersTermsAndContractualDocs: 10,
			partnersSalesTools: 10,
			partnersArchive: 10,
		}
	},
	mounted() {
		initBondCards()
	}
}
